import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { billingClient } from '@/lib/api/ts-rest';
import { createLogger } from '@/lib/logger';

export function useImportBillingRun() {
  const log = createLogger('useImportBillingRun');
  return useMutation({
    mutationFn: async (params: {
      billedMonth: number;
      billedYear: number;
      subscriptionFiles: File[];
      consumptionFiles: File[];
    }) => {
      const formData = new FormData();
      // Several files share the same field name → received as an array server-side.
      for (const file of params.subscriptionFiles) {
        formData.append('subscriptionFile', file);
      }
      for (const file of params.consumptionFiles) {
        formData.append('consumptionFile', file);
      }
      formData.append('billedMonth', String(params.billedMonth));
      formData.append('billedYear', String(params.billedYear));
      const res = await billingClient.importRun({ body: formData });
      if (res.status !== 201) throw new Error('Import failed');
      return res.body;
    },
    onSuccess: (result) => {
      toast.success(
        `Import terminé : ${result.subscriptionCount} abonnements, ${result.consumptionCount} consommations` +
          (result.supersededCount > 0
            ? ` — ${result.supersededCount} import(s) précédent(s) remplacé(s)`
            : ''),
      );
    },
    onError: (error) => {
      toast.error(
        error instanceof Error ? error.message : "L'import a échoué"
      );
      log.error('Billing import failed', { error });
    },
  });
}
